import cn from 'classnames';
import React from 'react';
import { DH } from '../../utils/DataHook';
import styles from './styles.scss';

export interface LoaderProps {
  size?: 'small' | 'medium' | 'large' | 'xsmall';
}

export const Loader: React.FC<LoaderProps> = (props) => {
  const { size } = props;
  const sizeClass = size ? styles[size] : null;
  return <i className={cn(styles.loader, sizeClass)} data-hook={DH.BaseLoader} />;
};
Loader.displayName = 'Loader';
